import PocketBase from 'pocketbase';

export const pb = new PocketBase('https://db.reputrust.ai');

// Listen to auth state changes to persist it
pb.authStore.onChange((token, model) => {
    // console.log('Auth changed:', model);
});
